import { Tag } from '@cian/components';
import * as React from 'react';

import { IFurnitureTag } from '../../../state/tags/definitions/furniture';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IFurnitureTagItemProps {
  tag: IFurnitureTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const FurnitureTagItem = ({ tag, onDeleteClick, withNewTag }: IFurnitureTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {(tag.value && 'С мебелью') || 'Без мебели'}
    </TagComponent>
  );
};
